import React from "react";
import SvgIcon from "material-ui/SvgIcon";

const Palette = (props) => (
    <SvgIcon {...props}>
        <path
            d="M12,0c5.1,0,9.6,3.2,11.3,8.1c0.5,1.3,0.7,2.7,0.7,4.1c-0.1,2.3-2.2,4.1-4.5,3.8c-1.1-0.2-2.3-0.4-3.4-0.6
        c-0.4-0.1-0.9-0.2-1.3-0.3c-1.4-0.3-2.6,1-2.1,2.3c0.1,0.4,0.5,0.7,0.8,1c0.4,0.3,0.8,0.6,1,1c1.2,1.8,0.1,4.3-2,4.6
        c-0.8,0.1-1.5,0-2.2-0.1c-2.4-0.4-4.6-1.4-6.4-3.1c-2-1.9-3.3-4.2-3.7-6.9c-0.6-3.8,0.4-7.2,3.1-10.1c1.8-2,4.1-3.2,6.8-3.7
        C10.4,0.1,10.7,0,11,0S11.6,0,12,0z M6.6,4.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8C8.4,5.6,7.6,4.8,6.6,4.8z
         M12.6,6c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8S11.6,6,12.6,6z M4.2,10.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8
        S6,13.6,6,12.6S5.2,10.8,4.2,10.8z M16.8,7.8c0,1,0.8,1.8,1.7,1.8c1,0,1.8-0.7,1.9-1.8c0-1-0.8-1.8-1.7-1.8
        C17.7,6,16.8,6.8,16.8,7.8z"
        />
    </SvgIcon>
);

export default Palette;
